module.exports = __webpack_public_path__ + "img/ultra_touch_denim_logo.d6a6924d.jpg";